import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineL } from '@sorare/core/src/atoms/typography';
import { CardsShow } from '@sorare/marketplace/src/components/card/CardsShow';

import type { CompleteCollectionModal_anyCard } from './__generated__/index.graphql.ts';

const Root = styled(Vertical).attrs({ center: true })`
  padding: var(--double-unit);
  height: 100%;
  justify-content: space-between;
`;

type Props = {
  cards: CompleteCollectionModal_anyCard[];
};
export const CompleteCollectionModal = ({ cards }: Props) => {
  const max5Cards = cards.slice(0, 5);

  return (
    <Root className="text-center" gap={3}>
      <Vertical gap={3}>
        <CardsShow cards={max5Cards} specialFive />
        <HeadlineL>
          <FormattedMessage
            id="CompleteCollectionModal.headline"
            defaultMessage="You're about to add {count, plural, one {# card} other {# cards}} to your cart to complete your collection!"
            values={{
              count: cards.length,
            }}
          />
        </HeadlineL>
      </Vertical>
    </Root>
  );
};

CompleteCollectionModal.fragments = {
  anyCard: gql`
    fragment CompleteCollectionModal_anyCard on AnyCardInterface {
      slug
      ...CardsShow_anyCard
    }
    ${CardsShow.fragments.anyCard}
  ` as TypedDocumentNode<CompleteCollectionModal_anyCard>,
};
